import React, { useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
import RangeSlider from "react-bootstrap-range-slider";

const GoalTrackingModal = () => {
  const [value, setValue] = useState(25);
  const selectActive = [
    { label: "Active", value: "option1" },
    { label: "Inactive", value: "option2" },
  ];
  const selectGoal = [
    { label: "Invoice Goal", value: "option1" },
    { label: "Event Goal", value: "option2" },
  ];
  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
      color: state.isFocused ? "#fff" : "#000",
      "&:hover": {
        backgroundColor: "#ff9b44",
      },
    }),
  };
  const [selectedDate1, setSelectedDate1] = useState(null);
  const [selectedDate2, setSelectedDate2] = useState(null);
  const [selectedDate3, setSelectedDate3] = useState(null);
  const [selectedDate4, setSelectedDate4] = useState(null);

  const handleDateChange1 = (date) => {
    setSelectedDate1(date);
  };
  const handleDateChange2 = (date) => {
    setSelectedDate2(date);
  };
  const handleDateChange3 = (date) => {
    setSelectedDate3(date);
  };
  const handleDateChange4 = (date) => {
    setSelectedDate4(date);
  };
  return (
    <>
      {/* Add Goal Modal */}
      <div id="add_goal" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Property Visit</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Branch</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Customer Name</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Mobile Number</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Purpose</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Application</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-sm-6">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="yesCheckboxAdd"
                      />
                      <label className="form-check-label" htmlFor="yesCheckboxAdd">
                        Yes
                      </label>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="noCheckboxAdd"
                      />
                      <label className="form-check-label" htmlFor="noCheckboxAdd">
                        No
                      </label>
                    </div>
                  </div>
                </div>
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    type="reset"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Goal Modal */}
      {/* Edit Goal Modal */}
      <div id="edit_goal" className="modal custom-modal fade" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Goal Tracking</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Goal Type</label>
                      <Select
                        options={selectGoal}
                        placeholder="Invoice Goal"
                        styles={customStyles}
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Subject</label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue="Test Goal"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Target Achievement
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        defaultValue="Lorem ipsum dollar"
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label>
                        Start Date <span className="text-danger">*</span>
                      </label>
                      <div className="cal-icon">
                        <DatePicker
                          selected={selectedDate3}
                          onChange={handleDateChange3}
                          className="form-control floating datetimepicker"
                          type="date"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label>
                        End Date <span className="text-danger">*</span>
                      </label>
                      <div className="cal-icon">
                        <DatePicker
                          selected={selectedDate4}
                          onChange={handleDateChange4}
                          className="form-control floating datetimepicker"
                          type="date"
                          dateFormat="dd-MM-yyyy"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12 mb-3">
                    <div className="input-block mb-3">
                      <label>Progress</label>
                      <RangeSlider
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                      />
                      <div className="mt-2" id="result">
                        Progress Value: <b>{value}</b>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="input-block mb-3">
                      <label>
                        Description <span className="text-danger">*</span>
                      </label>
                      <textarea
                        className="form-control"
                        rows={4}
                        defaultValue={"Lorem ipsum dollar"}
                      />
                    </div>
                  </div>
                </div>
               
                <div className="submit-section">
                  <button
                    className="btn btn-primary submit-btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    type="reset"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* /Edit Goal Modal */}
    </>
  );
};

export default GoalTrackingModal;







// import React, { useState } from "react";
// import Select from "react-select";
// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";
// import "react-bootstrap-range-slider/dist/react-bootstrap-range-slider.css";
// import RangeSlider from "react-bootstrap-range-slider";

// const GoalTrackingModal = () => {
//   const [value, setValue] = useState(25);
//   const selectActive = [
//     { label: "Active", value: "option1" },
//     { label: "Inactive", value: "option2" },
//   ];
//   const selectGoal = [
//     { label: "Invoice Goal", value: "option1" },
//     { label: "Event Goal", value: "option2" },
//   ];
//   const customStyles = {
//     option: (provided, state) => ({
//       ...provided,
//       backgroundColor: state.isFocused ? "#ff9b44" : "#fff",
//       color: state.isFocused ? "#fff" : "#000",
//       "&:hover": {
//         backgroundColor: "#ff9b44",
//       },
//     }),
//   };
//   const [selectedDate1, setSelectedDate1] = useState(null);
//   const [selectedDate2, setSelectedDate2] = useState(null);
//   const [selectedDate3, setSelectedDate3] = useState(null);
//   const [selectedDate4, setSelectedDate4] = useState(null);

//   const handleDateChange1 = (date) => {
//     setSelectedDate1(date);
//   };
//   const handleDateChange2 = (date) => {
//     setSelectedDate2(date);
//   };
//   const handleDateChange3 = (date) => {
//     setSelectedDate3(date);
//   };
//   const handleDateChange4 = (date) => {
//     setSelectedDate4(date);
//   };
//   return (
//     <>
//       {/* Add Goal Modal */}
//       <div id="add_goal" className="modal custom-modal fade" role="dialog">
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Add Goal Tracking</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                 <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Branch</label>
//                       <input className="form-control" type="text" />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name</label>
//                       <input className="form-control" type="text" />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Mobile Number</label>
//                       <input className="form-control" type="text" />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                      Purpose
//                       </label>
//                       <input className="form-control" type="text" />
//                     </div>
//                   </div>
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Application</label>
//                       <input className="form-control" type="text" />
//                     </div>
//                   </div>
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Status</label>
//                       <Select
//                         options={selectActive}
//                         placeholder="Active"
//                         styles={customStyles}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* /Add Goal Modal */}
//       {/* Edit Goal Modal */}
//       <div id="edit_goal" className="modal custom-modal fade" role="dialog">
//         <div className="modal-dialog modal-dialog-centered" role="document">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Goal Tracking</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Goal Type</label>
//                       <Select
//                         options={selectGoal}
//                         placeholder="Invoice Goal"
//                         styles={customStyles}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Subject</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Test Goal"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Target Achievement
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Lorem ipsum dollar"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label>
//                         Start Date <span className="text-danger">*</span>
//                       </label>
//                       <div className="cal-icon">
//                         <DatePicker
//                           selected={selectedDate3}
//                           onChange={handleDateChange3}
//                           className="form-control floating datetimepicker"
//                           type="date"
//                           dateFormat="dd-MM-yyyy"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-sm-6">
//                     <div className="input-block mb-3">
//                       <label>
//                         End Date <span className="text-danger">*</span>
//                       </label>
//                       <div className="cal-icon">
//                         <DatePicker
//                           selected={selectedDate4}
//                           onChange={handleDateChange4}
//                           className="form-control floating datetimepicker"
//                           type="date"
//                           dateFormat="dd-MM-yyyy"
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-sm-12 mb-3">
//                     <div className="input-block mb-3">
//                       <label>Progress</label>
//                       <RangeSlider
//                         value={value}
//                         onChange={(e) => setValue(e.target.value)}
//                       />
//                       <div className="mt-2" id="result">
//                         Progress Value: <b>{value}</b>
//                       </div>
//                     </div>
//                   </div>
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label>
//                         Description <span className="text-danger">*</span>
//                       </label>
//                       <textarea
//                         className="form-control"
//                         rows={4}
//                         defaultValue={"Lorem ipsum dollar"}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-sm-12">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Status</label>
//                       <Select
//                         options={selectActive}
//                         placeholder="Active"
//                         styles={customStyles}
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* /Edit Goal Modal */}
//     </>
//   );
// };

// export default GoalTrackingModal;
